import config from "./configuration";
import ConstantsList from '../common/Constants';
const API_BASE_URL = config.BASE_URL + "api/dashboard";

// this block needed to get the login Token and Login user _id
let localData = localStorage.getItem("userData");
let userData = {};
if (localData) {
  userData = JSON.parse(localData);
}

const buildPayload = ({ fromDate, toDate, targetProduction, deptCode = "" }) => ({
  timeZone: "Asia/Kolkata",
  filter: {
    fromDate,
    toDate,
    ...(deptCode ? { deptCode } : {}),
    ...(targetProduction ? { targetProduction: Number(targetProduction) } : {}),
  },
});

const postRequest = async (endpoint, payload) => {
  try {
    const response = await fetch(`${API_BASE_URL}${endpoint}`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${userData.token}`,
      },
      body: JSON.stringify(payload),
    });

    const result = await response.json();

    // if (!response.ok) {
    //   throw new Error(result?.message || "API request failed");
    // }

    if (result.statusCode === 401) {
      console.log(">> Session Timeout", result);
      localStorage.removeItem("token");
      localStorage.removeItem("userData");
      window.location.href = ConstantsList.LOGIN;
      alert("Session expired. Please login again.");
      return;
    } else {
      return result;
    }

    // return result;
  } catch (error) {
    console.error(`Dashboard API Error: ${endpoint}`, error);
    throw error;
  }
};

export const dashboardApi = {
  getProductionToday: (filters) =>
    postRequest("/getProductionToday", buildPayload(filters)),

  getMachineUtilization: (filters) =>
    postRequest("/getMachineUtilization", buildPayload(filters)),

  getDepartmentsSummary: () =>
    postRequest("/getDepartmentsSummary", {
      timeZone: "Asia/Kolkata",
    }),

  getRejectionRate: (filters) =>
    postRequest("/getRejectionRate", buildPayload(filters)),

  getOperatorsSummary: (filters) =>
    postRequest("/getOperatorsSummary", buildPayload(filters)),

  getActiveJobCards: (filters) =>
    postRequest("/getActiveJobCards", buildPayload(filters)),

  getProductionDashboard: (filters) =>
    postRequest("/production", buildPayload(filters)),

  getProductionDepartmentDetails: ({
    filters,
    deptCode,
    detailType,
    page = 1,
    perPage = 25,
    search = "",
  }) =>
    postRequest("/production/department-details", {
      ...buildPayload(filters),
      deptCode,
      detailType,
      page,
      perPage,
      search,
    }),

  getMachineUtilizationCompleteData: (filters) =>
    postRequest("/machine-utilization", buildPayload(filters)),

  getOperatorUtilization: (filters) =>
    postRequest("/operator-utilization", buildPayload(filters)),
};
